export const OPT_SESSSION_IDENTIFIER = 'cs-session-identifier';
export const OPT_USERTOKEN = 'cs-usertoken';
export const OPT_VISITOR_ID = 'cs-visitor-session-id';
